import {useCallback} from 'react';
import {useExpertLink} from '~/modules/Common/hooks/useExpertLink';

export function useLoadCollection() {
  const apiLink = useExpertLink(`/api/collection/`);

  return useCallback(
    async (id: string, page = 1, limit = 10, filterVisible = true) => {
      const response = await fetch(`${apiLink}${id}`, {
        method: 'POST',
        body: JSON.stringify({page, limit, filterVisible}),
      });
      const result = await response.json();
      return result;
    },
    [apiLink],
  );
}
